export const handleChangeDataWalletPage = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_WALLET', name, value
});